import * as React from 'react';
import cx from 'classnames';

import Checkbox from 'components/Checkbox';
import { DisabledTooltipLayer } from './SelectFromList';
import EventTracking from 'lib/EventTracking';
import MediaObject from 'components/MediaObject';
import OrgAvatar from 'organizations/components/OrgAvatar';
import TargetFilterMenu from 'chat_v2/components/TargetFilterMenu';
import Text from 'components/Text';
import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';
import { ComposerDispatchContext, ComposerStateContext } from 'chat_v2/ComposerContext';
import { ComposerContext } from './ComposerContext';

type Props = {
  entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity,
  recipientIsSelected: boolean,
  disabledCopy?: string,
};

export default class OrganizationRecipientItem extends React.Component<Props> {
  render() {
    const { entity, disabledCopy, recipientIsSelected } = this.props;
    const { recipient, content } = entity;

    const filterArray = recipient.filters?.map(filter => (
      <ComposerStateContext.Consumer>
        {composerState =>
          <TargetFilterMenu
            key={filter.key}
            filter={filter}
            entity={entity}
            dataTestSelector={`split-composer-organization-filter-${recipient.uuid}`}
            composerState={composerState}
          />
        }
      </ComposerStateContext.Consumer>
    ));

    const component = (
      <ComposerDispatchContext.Consumer>
        {composerDispatch => (
          <ComposerContext.Consumer>
            {composerContext => { 
              const selectionHandler = (event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent) => {
                event.preventDefault();

                if (recipientIsSelected) {
                  composerDispatch({ type: 'removeRecipient', uuid: recipient.uuid });
                } else {
                  composerDispatch({ type: 'addRecipient', entity });
                }

                EventTracking.trackKey(`announcements.share_to.organization.${recipientIsSelected ? 'un' : ''}select.click`, { organization_uuid: recipient.uuid, ...composerContext.getUIEventContext() });
              };

              return (
                <li
                  className={cx('RecipientItem', {
                    'RecipientItem--disabled': !!disabledCopy,
                  })}
                  onClick={selectionHandler}
                  data-test-selector={`split-composer-organization-${recipient.uuid}`}>
                  <MediaObject figure="right" center>
                    <MediaObject gutter="small" center>
                      <OrgAvatar size="medium" />
                      <div>
                        <Text size="small" element="div" truncate>
                          {content.title}
                        </Text>
                        {filterArray}
                      </div>
                    </MediaObject>
                    <Checkbox onChange={selectionHandler} checked={recipientIsSelected} />
                  </MediaObject>
                </li>
              );
            }}
          </ComposerContext.Consumer>
        )}
      </ComposerDispatchContext.Consumer>
    );

    return disabledCopy ? (
      <DisabledTooltipLayer text={disabledCopy}>{component}</DisabledTooltipLayer>
    ) : (
      component
    );
  }
}
